module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/mapaDopravnichProudu-1af0d9343b85d499f5c55dd0da951689.png";